// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file webgame/v1/crew_map.proto (package webgame.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Bounds, LatLng } from "./geo_pb";
import { file_webgame_v1_geo } from "./geo_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file webgame/v1/crew_map.proto.
 */
export const file_webgame_v1_crew_map: GenFile = /*@__PURE__*/
  fileDesc("Chl3ZWJnYW1lL3YxL2NyZXdfbWFwLnByb3RvEgp3ZWJnYW1lLnYxIjwKEUdldENyZXdNYXBSZXF1ZXN0EicKC2hlYXRfYm91bmRzGAEgASgLMhIud2ViZ2FtZS52MS5Cb3VuZHMigQIKCkNyZXdNYXJrZXISEQoJcGxheWVyX2lkGAEgASgJEioKCHJlbGF0aW9uGAIgASgOMhgud2ViZ2FtZS52MS5DcmV3UmVsYXRpb24SEQoJaXNfZnJpZW5kGAMgASgIEhAKCG5pY2tuYW1lGAQgASgJEg8KB2ZhY3Rpb24YBSABKAkSDQoFbGV2ZWwYBiABKAUSEgoKZmFtaWx5X3RhZxgHIAEoCRILCgNsYXQYCCABKAESCwoDbG5nGAkgASgBEhIKCnRzX3VuaXhfbXMYCiABKAMSDgoGZG93bmVkGAsgASgIEh0KFWxheV9sb3dfdW50aWxfdW5peF9tcxgMIAEoAyJBCgtGYWN0aW9uSGVhdBIPCgdmYWN0aW9uGAEgASgJEgwKBGJhbmQYAiABKAUSEwoLY291bnRfZmxvb3IYAyABKAUiwAEKCEhlYXRDZWxsEhAKCHMyX3Rva2VuGAEgASgJEiIKBmNlbnRlchgCIAEoCzISLndlYmdhbWUudjEuTGF0TG5nEiQKCHZlcnRpY2VzGAMgAygLMhIud2ViZ2FtZS52MS5MYXRMbmcSEgoKdG90YWxfYmFuZBgEIAEoBRIZChF0b3RhbF9jb3VudF9mbG9vchgFIAEoBRIpCghmYWN0aW9ucxgGIAMoCzIXLndlYmdhbWUudjEuRmFjdGlvbkhlYXQi1wIKEkdldENyZXdNYXBSZXNwb25zZRIWCg5zeXN0ZW1fZW5hYmxlZBgBIAEoCBIkCgRjcmV3GAIgAygLMhYud2ViZ2FtZS52MS5DcmV3TWFya2VyEiIKBGhlYXQYAyADKAsyFC53ZWJnYW1lLnYxLkhlYXRDZWxsEhUKDWhlYXRfczJfbGV2ZWwYBCABKAUSFgoOaGVhdF9taW5fY291bnQYBSABKAUSFgoOaGVhdF90cnVuY2F0ZWQYBiABKAgSIQoZaGVhdF9nZW5lcmF0ZWRfYXRfdW5peF9tcxgHIAEoAxIbChNzZXJ2ZXJfdGltZV91bml4X21zGAggASgDEiAKGGZhbWlseV9wb3NpdGlvbnNfZW5hYmxlZBgJIAEoCBIgChhmcmllbmRfcG9zaXRpb25zX2VuYWJsZWQYCiABKAgSFAoMaGVhdF9lbmFibGVkGAsgASgIKnkKDENyZXdSZWxhdGlvbhIdChlDUkVXX1JFTEFUSU9OX1VOU1BFQ0lGSUVEEAASFgoSQ1JFV19SRUxBVElPTl9TRUxGEAESGAoUQ1JFV19SRUxBVElPTl9GQU1JTFkQAhIYChRDUkVXX1JFTEFUSU9OX0ZSSUVORBADMl0KDkNyZXdNYXBTZXJ2aWNlEksKCkdldENyZXdNYXASHS53ZWJnYW1lLnYxLkdldENyZXdNYXBSZXF1ZXN0Gh4ud2ViZ2FtZS52MS5HZXRDcmV3TWFwUmVzcG9uc2VCN1o1Z2l0aHViLmNvbS9tYWZpYWdvL3NlcnZlci9nZW4vZ28vd2ViZ2FtZS92MTt3ZWJnYW1ldjFiBnByb3RvMw", [file_webgame_v1_geo]);

/**
 * @generated from message webgame.v1.GetCrewMapRequest
 */
export type GetCrewMapRequest = Message<"webgame.v1.GetCrewMapRequest"> & {
  /**
   * The area to report rival heat for (normally the padded viewport). Crew
   * markers are NOT filtered by it — your crew is your crew wherever they are.
   *
   * @generated from field: webgame.v1.Bounds heat_bounds = 1;
   */
  heatBounds?: Bounds | undefined;
};

/**
 * Describes the message webgame.v1.GetCrewMapRequest.
 * Use `create(GetCrewMapRequestSchema)` to create a new message.
 */
export const GetCrewMapRequestSchema: GenMessage<GetCrewMapRequest> = /*@__PURE__*/
  messageDesc(file_webgame_v1_crew_map, 0);

/**
 * @generated from message webgame.v1.CrewMarker
 */
export type CrewMarker = Message<"webgame.v1.CrewMarker"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * FAMILY wins over FRIEND; is_friend is still set for a family member who
   * is also a friend.
   *
   * @generated from field: webgame.v1.CrewRelation relation = 2;
   */
  relation: CrewRelation;

  /**
   * @generated from field: bool is_friend = 3;
   */
  isFriend: boolean;

  /**
   * @generated from field: string nickname = 4;
   */
  nickname: string;

  /**
   * @generated from field: string faction = 5;
   */
  faction: string;

  /**
   * @generated from field: int32 level = 6;
   */
  level: number;

  /**
   * @generated from field: string family_tag = 7;
   */
  familyTag: string;

  /**
   * @generated from field: double lat = 8;
   */
  lat: number;

  /**
   * @generated from field: double lng = 9;
   */
  lng: number;

  /**
   * When this position was reported (server clock, unix ms).
   *
   * @generated from field: int64 ts_unix_ms = 10;
   */
  tsUnixMs: bigint;

  /**
   * @generated from field: bool downed = 11;
   */
  downed: boolean;

  /**
   * @generated from field: int64 lay_low_until_unix_ms = 12;
   */
  layLowUntilUnixMs: bigint;
};

/**
 * Describes the message webgame.v1.CrewMarker.
 * Use `create(CrewMarkerSchema)` to create a new message.
 */
export const CrewMarkerSchema: GenMessage<CrewMarker> = /*@__PURE__*/
  messageDesc(file_webgame_v1_crew_map, 1);

/**
 * @generated from message webgame.v1.FactionHeat
 */
export type FactionHeat = Message<"webgame.v1.FactionHeat"> & {
  /**
   * @generated from field: string faction = 1;
   */
  faction: string;

  /**
   * 1..5 for the lower bounds 3, 5, 10, 20, 50. Never an exact count.
   *
   * @generated from field: int32 band = 2;
   */
  band: number;

  /**
   * The lower bound of the band (3, 5, 10, 20 or 50).
   *
   * @generated from field: int32 count_floor = 3;
   */
  countFloor: number;
};

/**
 * Describes the message webgame.v1.FactionHeat.
 * Use `create(FactionHeatSchema)` to create a new message.
 */
export const FactionHeatSchema: GenMessage<FactionHeat> = /*@__PURE__*/
  messageDesc(file_webgame_v1_crew_map, 2);

/**
 * @generated from message webgame.v1.HeatCell
 */
export type HeatCell = Message<"webgame.v1.HeatCell"> & {
  /**
   * @generated from field: string s2_token = 1;
   */
  s2Token: string;

  /**
   * @generated from field: webgame.v1.LatLng center = 2;
   */
  center?: LatLng | undefined;

  /**
   * The cell's 4 corners, counter-clockwise, so the browser needs no S2
   * library to draw it.
   *
   * @generated from field: repeated webgame.v1.LatLng vertices = 3;
   */
  vertices: LatLng[];

  /**
   * @generated from field: int32 total_band = 4;
   */
  totalBand: number;

  /**
   * @generated from field: int32 total_count_floor = 5;
   */
  totalCountFloor: number;

  /**
   * Only factions that individually clear the threshold.
   *
   * @generated from field: repeated webgame.v1.FactionHeat factions = 6;
   */
  factions: FactionHeat[];
};

/**
 * Describes the message webgame.v1.HeatCell.
 * Use `create(HeatCellSchema)` to create a new message.
 */
export const HeatCellSchema: GenMessage<HeatCell> = /*@__PURE__*/
  messageDesc(file_webgame_v1_crew_map, 3);

/**
 * @generated from message webgame.v1.GetCrewMapResponse
 */
export type GetCrewMapResponse = Message<"webgame.v1.GetCrewMapResponse"> & {
  /**
   * FALSE → the feature is dark: crew and heat are empty, not an error.
   *
   * @generated from field: bool system_enabled = 1;
   */
  systemEnabled: boolean;

  /**
   * @generated from field: repeated webgame.v1.CrewMarker crew = 2;
   */
  crew: CrewMarker[];

  /**
   * @generated from field: repeated webgame.v1.HeatCell heat = 3;
   */
  heat: HeatCell[];

  /**
   * @generated from field: int32 heat_s2_level = 4;
   */
  heatS2Level: number;

  /**
   * @generated from field: int32 heat_min_count = 5;
   */
  heatMinCount: number;

  /**
   * The heat bounds were clamped or covered by more cells than the cap.
   *
   * @generated from field: bool heat_truncated = 6;
   */
  heatTruncated: boolean;

  /**
   * When the heat snapshot was computed (0 = no snapshot yet).
   *
   * @generated from field: int64 heat_generated_at_unix_ms = 7;
   */
  heatGeneratedAtUnixMs: bigint;

  /**
   * @generated from field: int64 server_time_unix_ms = 8;
   */
  serverTimeUnixMs: bigint;

  /**
   * @generated from field: bool family_positions_enabled = 9;
   */
  familyPositionsEnabled: boolean;

  /**
   * @generated from field: bool friend_positions_enabled = 10;
   */
  friendPositionsEnabled: boolean;

  /**
   * @generated from field: bool heat_enabled = 11;
   */
  heatEnabled: boolean;
};

/**
 * Describes the message webgame.v1.GetCrewMapResponse.
 * Use `create(GetCrewMapResponseSchema)` to create a new message.
 */
export const GetCrewMapResponseSchema: GenMessage<GetCrewMapResponse> = /*@__PURE__*/
  messageDesc(file_webgame_v1_crew_map, 4);

/**
 * @generated from enum webgame.v1.CrewRelation
 */
export enum CrewRelation {
  /**
   * @generated from enum value: CREW_RELATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREW_RELATION_SELF = 1;
   */
  SELF = 1,

  /**
   * @generated from enum value: CREW_RELATION_FAMILY = 2;
   */
  FAMILY = 2,

  /**
   * @generated from enum value: CREW_RELATION_FRIEND = 3;
   */
  FRIEND = 3,
}

/**
 * Describes the enum webgame.v1.CrewRelation.
 */
export const CrewRelationSchema: GenEnum<CrewRelation> = /*@__PURE__*/
  enumDesc(file_webgame_v1_crew_map, 0);

/**
 * CrewMapService puts PEOPLE on the web map. Served by cmd/auth.
 *
 * THE PRIVACY CONTRACT. These are real people at their real GPS positions,
 * and the web map can be panned anywhere, so the rule is:
 *   - Crew (self, family members, and — only if friend_positions_enabled —
 *     friends) appear at their exact position, and ONLY while they are
 *     actively playing (a live player:loc entry). An offline crew member has
 *     no marker; there is no "last known position" for anyone but yourself.
 *   - Everyone else is never an individual. They exist only as coarse S2 heat
 *     cells, per faction, behind a k-anonymity threshold (heat_min_count,
 *     never below 3), reported as BANDS rather than counts, with every crew
 *     member the viewer can already see subtracted before the threshold.
 *   - Anyone in a block relation with the viewer (either direction) is never
 *     crew; they fall into heat like any rival.
 *
 * NOTE friends.proto says a friendship grants "exactly one thing — visibility
 * of each other's online state". Friend POSITIONS are a new disclosure, which
 * is why friend_positions_enabled ships FALSE and the whole service ships dark
 * (crew_map_config.system_enabled = FALSE). That file is mirrored by Unity and
 * is deliberately not edited; this comment is the record.
 *
 * @generated from service webgame.v1.CrewMapService
 */
export const CrewMapService: GenService<{
  /**
   * @generated from rpc webgame.v1.CrewMapService.GetCrewMap
   */
  getCrewMap: {
    methodKind: "unary";
    input: typeof GetCrewMapRequestSchema;
    output: typeof GetCrewMapResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_webgame_v1_crew_map, 0);

